import editAdminInfo from '../../apis/editAdminInfo'
import usericon from '../../assets/icons/user.svg'
import { useState } from 'react'
import { useAuth } from '../../hooks/AuthContext'

const AdminInfo = () => {
  const { user, login } = useAuth()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name,
  })

  const handelEdit = async (event) => {
    event.preventDefault()
    console.log('start')
    const editedData = new FormData()

    let edited = false
    if (user.email !== formData.email) {
      editedData.append('email', formData.email)
      edited = true
    }
    if (user.first_name !== formData.first_name) {
      editedData.append('first_name', formData.first_name)
      edited = true
    }
    if (user.last_name !== formData.last_name) {
      editedData.append('last_name', formData.last_name)
      edited = true
    }

    if (edited) {
      setLoading(true)

      try {
        const response = await editAdminInfo(editedData, user.user_id)
        console.log('edited data', response)
        login({ ...user, ...response.original.data })
      } catch (error) {
        console.log(error)
        setError('could not update admin')
      } finally {
        setLoading(false)
      }
    }
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setError('')
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }))
  }
  return (
    <div className=" w-full ">
      <p className=" text-darkBlue py-2">
        Update your admin profile information
      </p>
      <form onSubmit={handelEdit} className=" flex w-1/2 flex-col gap-3">
        <div className=" flex flex-col gap-2">
          <label className=" text-blueButton">First Name</label>
          <div className="w-full rounded-xl p-1 gap-2 border-[1px] border-blueButton flex ">
            <img src={usericon} alt="" className="w-1/12" />
            <input
              name="first_name"
              value={formData.first_name}
              type="text"
              onChange={handleInputChange}
              placeholder="first name"
              className=" w-11/12 focus:outline-none"
              required
            />
          </div>
        </div>
        <div className=" flex flex-col gap-2">
          <label className=" text-blueButton">Last Name</label>

          <div className="w-full rounded-xl p-1 gap-2 border-[1px] border-blueButton flex ">
            <img src={usericon} alt="" className="w-1/12" />
            <input
              name="last_name"
              value={formData.last_name}
              type="text"
              onChange={handleInputChange}
              placeholder="last name"
              className=" w-11/12 focus:outline-none"
              required
            />
          </div>
          <div className=" flex flex-col gap-2">
            <label className=" text-blueButton">Email</label>
            <div className="w-full rounded-xl p-1 gap-2 border-[1px] border-blueButton flex ">
              <img src={usericon} alt="" className="w-1/12" />
              <input
                name="email"
                value={formData.email}
                type="email"
                onChange={handleInputChange}
                placeholder="Email"
                className=" w-11/12 focus:outline-none"
                required
              />
            </div>
          </div>
          {error && (
            <div className=" bg-red/30 p-1 rounded text-red">{error}</div>
          )}
          <button
            disabled={loading}
            type="submit"
            className=" flex gap-2 disabled:bg-blueButton/60 bg-blueButton transition-all duration-300 text-2xl hover:scale-105 text-white text-center w-full p-3 rounded-xl"
          >
            {loading && (
              <div
                style={{
                  borderColor: `#A9A9A9 transparent #A9A9A9 transparent`,
                }}
                className=" border-2 w-1/12 aspect-square animate-spin rounded-full "
              ></div>
            )}
            <span className={`${loading ? 'w-11/12' : 'w-full'}`}>
              Edit Info
            </span>
          </button>
        </div>
      </form>
    </div>
  )
}

export default AdminInfo
